import { VAS } from "./vas.model";
import { Lead } from "./lead.model";
import { Task } from "./task.model";
import { Settings } from "./settings.model";
import { Configuration } from "./configuration.model";
import { ProvisioningInfo } from "./provisioning-info.model";

export class Merchant {

    id!: number;
    partnerId!: number;
    name!: string;

    street?: string;
    city?: string;
    state?: string;
    postal?: string;
    country?: string;
    timeZone?: string;
    locale?: string;

    phone!: string;
    latitude?: number;
    longitude?: number;

    ordyxId!: number;
    chargeId?: string;
    crmId?: string;
    deskId!: string;

    serviceType?: string;
    offering?: string[];

    vas = new VAS();
    settings = new Settings();
    configuration = new Configuration();
    provisioning = new ProvisioningInfo();

    installTotal?: number;
    tasks?: Task[];

    paid?: Date;
    opening?: Date;
    live?: Date;
    cancelled?: Date;
    created?: Date;
    updated?: Date;

    public load(data: any): Merchant {
        Object.assign(this, data);

        if (data?.settings){
            this.settings = new Settings().load(data.settings);
        }

        if (data?.configuration){
            this.configuration = new Configuration().load(data.configuration);
        }

        if (data?.provisioning){
            this.provisioning = new ProvisioningInfo().load(data.provisioning);
        } else {
            this.provisioning = new ProvisioningInfo().load({});
        }

        if (data?.vas){
            this.vas = new VAS().load(data.vas);
        }

        if (data?.paid) {
            this.paid = new Date(data.paid);
        }

        if (data?.opening) {
            this.opening = new Date(data.opening);
        }

        if (data?.cancelled) {
            this.cancelled = new Date(data.cancelled);
        }

        if (data?.created) {
            this.created = new Date(data.created);
        }

        if (data?.updated) {
            this.updated = new Date(data.updated);
        }

        return this;
    }

    public loadLead(lead: Lead): Merchant {

        this.name = lead.establishment;
        this.phone = lead.phone;
        this.street = lead.street;
        this.city = lead.city;
        this.postal = lead.postal;
        this.country = lead.country;
        this.state = lead.state;

        this.vas = new VAS();
        this.settings = new Settings();
        this.configuration = new Configuration();
        this.provisioning = new ProvisioningInfo();

        return this;
    }
}
